import {Box, Container, styled, Stack, Grid} from '@mui/material';
import {RoundedButton, HeaderTag, HeaderText} from 'components';
import {BigBlogItem} from './BigBlogItem';
import {SmallBlogItem} from './SmallBlogItem';
import {useMatchesSize} from 'common/useMatchesSize';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import {useQuery} from 'react-query';
import {blogListApi} from 'api';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';

const openLinkInNewTab = (link) => {
  window.open(link, '_blank');
};

const Blog = () => {
  const {isMedium, isSmall} = useMatchesSize();
  const {data: queryRes} = useQuery('page', blogListApi);
  const blogs = queryRes?.data?.data || [];
  const {t} = useTranslation();

  return (
    <StyledBox>
      <Container>
        <HeaderTag
          label={t('header.blog')}
          sx={{marginBottom: 3.5, display: isSmall ? 'none' : 'inline-flex'}}
        />
        {isMedium || isSmall ? BlogMobile(blogs) : BlogDesktop(blogs)}
      </Container>
    </StyledBox>
  );
};

const BlogMobile = (blogs) => {
  const {t, i18n} = useTranslation();
  const items = blogs
    .slice(0, 3)
    .map((blog) => (
      <BigBlogItem
        img_url={'https://api.himegamiprotocol.org/storage/' + blog.img_path}
        title={blog.title}
        description={
          blog.description?.length > 90
            ? blog.description.substring(0, 90) + '...'
            : blog.description
        }
        publish_date={blog.date_post}
        onClick={() => openLinkInNewTab(blog.link)}
      />
    ));

  const history = useHistory();

  const handleOpenBlog = () => {
    if (i18n.language === 'ja-JP') {
      window.open('https://note.com/himegami/');
    } else {
      window.open('https://medium.com/@shinobiwallet');
    }
  };

  return (
    <Stack spacing={5}>
      <HeaderText isSmall={false}>{t('homepage.blog.title')}</HeaderText>
      <AliceCarousel disableButtonsControls items={items} />
      <Stack alignItems="center">
        <RoundedButton variant="contained" hasIcon onClick={handleOpenBlog}>
          {t('homepage.blog.see_all')}
        </RoundedButton>
      </Stack>
    </Stack>
  );
};

const BlogDesktop = (blogs) => {
  const {t, i18n} = useTranslation();
  const history = useHistory();
  const handleOpenBlog = () => {
    if (i18n.language === 'ja-JP') {
      window.open('https://note.com/himegami/');
    } else {
      window.open('https://medium.com/@shinobiwallet');
    }
  };
  if (blogs?.length < 3) return;

  return (
    <>
      <Stack direction="row" justifyContent="space-between" mb={11}>
        <HeaderText isSmall={false}>{t('homepage.blog.title')}</HeaderText>
        <RoundedButton variant="contained" hasIcon onClick={handleOpenBlog}>
          {t('homepage.blog.see_all')}
        </RoundedButton>
      </Stack>

      <Grid container spacing={3} sx={{height: (theme) => theme.spacing(70)}}>
        <Grid item xs={6}>
          <BigBlogItem
            img_url={
              'https://api.himegamiprotocol.org/storage/' + blogs[0].img_path
            }
            title={blogs[0].title}
            description={
              blogs[0].description?.length > 90
                ? blogs[0].description.substring(0, 90) + '...'
                : blogs[0].description
            }
            publish_date={blogs[0].date_post}
            onClick={() => openLinkInNewTab(blogs[0].link)}
          />
        </Grid>
        <Grid item container xs={6}>
          <Grid container spacing={3} direction="column" height="100%">
            <Grid item md={6} xs={12}>
              <SmallBlogItem
                img_url={
                  'https://api.himegamiprotocol.org/storage/' +
                  blogs[1].img_path
                }
                title={
                  blogs[1].title?.length > 50
                    ? blogs[1].title.substring(0, 50) + '...'
                    : blogs[1].title
                }
                description={
                  blogs[1].description?.length > 50
                    ? blogs[1].description.substring(0, 50) + '...'
                    : blogs[1].description
                }
                publish_date={blogs[1].date_post}
                onClick={() => openLinkInNewTab(blogs[1].link)}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <SmallBlogItem
                img_url={
                  'https://api.himegamiprotocol.org/storage/' +
                  blogs[2].img_path
                }
                title={
                  blogs[2].title?.length > 50
                    ? blogs[2].title.substring(0, 50) + '...'
                    : blogs[2].title
                }
                description={
                  blogs[2].description?.length > 50
                    ? blogs[2].description.substring(0, 50) + '...'
                    : blogs[2].description
                }
                publish_date={blogs[2].date_post}
                onClick={() => openLinkInNewTab(blogs[2].link)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const StyledBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(15, 0),
}));

export {Blog};
